export enum ProjectTypeEnum {
  PRE_SALES = "pre_sales",
  POST_SALES = "post_sales",
}

export enum FastPayStatusEnum {
  NOT_APPLICABLE = "N/A",
  PENDING_CLOSER = "Pending Closer",
  PENDING_PAYMENTS = "Pending Payments",
  PAID = "Paid",
}

export enum PrimaryContactEnum {
  SETTER = "seller",
  CLOSER = "closer",
  BOTH = "both",
}

export enum PreSalesMilestoneNameEnum {
  NEW = "New",
  QUALIFIED = "Qualified",
  PROPOSAL_REQUESTED = "Proposal Requested",
  PROPOSAL_CREATION = "Proposal Creation",
  PROPOSAL_GENERATED = "Proposal Generated",
  PROPOSAL_PRESENTED = "Proposal Presented",
  DOCUMENTS_OUT = "Documents Out",
  SALE_COMPLETE = "Sale Complete",
}

export enum PostSalesMilestoneNameEnum {
  CONTRACT_SIGNED = "Contract Signed",
  PROJECT_INTAKE = "Project Intake",
  PROJECT_START = "Project Start",
  SITE_SURVEY_SCHEDULED = "Site Survey Scheduled",
  SITE_SURVEY_COMPLETED = "Site Survey Completed",
  PROJECT_CONFIRMATION = "Project Confirmation",
  DESIGN_COMPLETED = "Design Completed",
  PERMIT_SUBMISSION = "Permit Submission",
  PERMIT_APPROVED = "Permit Approved",
  INSTALLATION_SCHEDULED = "Installation Scheduled",
  SUBMIT_INSTALLATION_COMPLETE = "Submitted Installation Complete",
  PERMISSION_TO_OPERATE = "Permission to Operate",
  PTO = "PTO",
}

export enum PostSalesMilestoneDisplayNameEnum {
  CONTRACT_SIGNED = "Contract Signed",
  SITE_SURVEY_SCHEDULED = "Site Survey Scheduled",
  PROJECT_CONFIRMATION = "Project Confirmation",
  BUILDABLE_PROJECT = "Buildable Project",
  DESIGN_COMPLETED = "Design Completed",
  PERMIT_SUBMISSION = "Permit Submission",
  PERMIT_APPROVED = "Permit Approved",
  INSTALLATION_SCHEDULED = "Installation Scheduled",
  SUBMIT_INSTALLATION_COMPLETE = "Submitted Installation Complete",
  FINAL_INSPECTION_SCHEDULED = "Final Inspection Scheduled",
  FINAL_INSPECTION_PASSED = "Final Inspection Passed",
  PTO_APPLICATION_SUBMITTED = "PTO Application Submitted",
  PERMISSION_TO_OPERATE = "Permission to Operate",
  POWUR_ON = "Powur On!",
}

export enum StageNameEnum {
  NEW = "New",
  QUALIFIED = "Qualified",
  PROPOSAL_REQUESTED = "Proposal Creation",
  PROPOSAL_PRESENTED = "Proposal Presentation",
  DOCUMENTS_OUT = "Documents Out",
  CONTRACT_SIGNED = "Contract Signed",
  SITE_SURVEY = "Site Survey",
  PROJECT_CONFIRMATION = "Project Confirmation",
  DESIGN = "Design",
  PERMITTING = "Permitting",
  INSTALLATION = "Installation",
  INSPECTION = "Inspection",
  PTO = "PTO",
  POWUR_ON = "Powur On!",
}

export enum NonrequestableReasonEnum {
  MISSING_AURORO_PERM = "missing_aurora_permission",
  OUTSIDE_AURORA_REGIONS = "outside_aurora_regions",
  AURORA_IN_PROGRESS = "aurora_in_progress",
  QUALIFY_INCOMPLETE = "qualify_incomplete",
  OUT_OF_SERVICE_AREA = "out_of_service_area",
  ALREADY_REQUESTED = "already_requested",
  NO_MENTOR = "no_mentor",
  ONLY_MENTOR = "only_mentor",
  INVALID_SERVICE_AREA = "service_area_unavailable",
  UNCERTIFIED_ORG_USER = "uncertified_enterprise_user",
  REQUEST_IN_PROGRESS = "proposal_request_in_progress",
  OUTSIDE_SOLO_REGIONS = "outside_solo_regions",
  LIGHTREACH_ALREADY_REQUESTED = "lightreach_already_requested",
  OUTSIDE_LIGHTREACH_REGIONS = "outside_lightreach_regions",
  OUTSIDE_VISION_REGIONS = "outside_vision_regions",
  ALL_PROPOSALS_NONREQUESTABLE = "all_proposals_nonrequestable",
  RESTRICTED_ENTERPRISE_USER = "restricted_enterprise_user",
  PROJECT_TYPE_LOCKED = "project_type_locked",
  OUTSIDE_BATTERY_REGIONS = "outside_battery_regions",
  LINKED_PROJECT_EXISTS = "linked_project_exists",
}

export enum ProjectActionsProposalReasonEnum {
  ALL_PROPOSALS_NONREQUESTABLE = NonrequestableReasonEnum.ALL_PROPOSALS_NONREQUESTABLE,
  RESTRICTED_ENTERPRISE_USER = NonrequestableReasonEnum.RESTRICTED_ENTERPRISE_USER,
  PROJECT_TYPE_LOCKED = NonrequestableReasonEnum.PROJECT_TYPE_LOCKED,
  OUTSIDE_BATTERY_REGIONS = NonrequestableReasonEnum.OUTSIDE_BATTERY_REGIONS,
  LINKED_PROJECT_EXISTS = NonrequestableReasonEnum.LINKED_PROJECT_EXISTS,
  ALREADY_REQUESTED = NonrequestableReasonEnum.ALREADY_REQUESTED,
  REQUEST_IN_PROGRESS = NonrequestableReasonEnum.REQUEST_IN_PROGRESS,
}

export enum RoofingNonrequestableReasonEnum {
  OUT_OF_SERVICE_AREA = NonrequestableReasonEnum.OUT_OF_SERVICE_AREA,
}

export enum ProposalNonrequestableReasonEnum {
  QUALIFY_INCOMPLETE = NonrequestableReasonEnum.QUALIFY_INCOMPLETE,
  ALREADY_REQUESTED = NonrequestableReasonEnum.ALREADY_REQUESTED,
  NO_MENTOR = NonrequestableReasonEnum.NO_MENTOR,
  ONLY_MENTOR = NonrequestableReasonEnum.ONLY_MENTOR,
  INVALID_SERVICE_AREA = NonrequestableReasonEnum.INVALID_SERVICE_AREA,
  UNCERTIFIED_ORG_USER = NonrequestableReasonEnum.UNCERTIFIED_ORG_USER,
  REQUEST_IN_PROGRESS = NonrequestableReasonEnum.REQUEST_IN_PROGRESS,
  LIGHTREACH_ALREADY_REQUESTED = NonrequestableReasonEnum.LIGHTREACH_ALREADY_REQUESTED,
}

export enum AuroraNonrequestableReasonEnum {
  MISSING_AURORO_PERM = NonrequestableReasonEnum.MISSING_AURORO_PERM,
  OUTSIDE_SERVICE_REGIONS = NonrequestableReasonEnum.OUTSIDE_AURORA_REGIONS,
  AURORA_IN_PROGRESS = NonrequestableReasonEnum.AURORA_IN_PROGRESS,
  QUALIFY_INCOMPLETE = NonrequestableReasonEnum.QUALIFY_INCOMPLETE,
}

export enum VisionNonrequestableReasonEnum {
  ALREADY_REQUESTED = NonrequestableReasonEnum.ALREADY_REQUESTED,
  OUTSIDE_SERVICE_REGIONS = NonrequestableReasonEnum.OUTSIDE_VISION_REGIONS,
  QUALIFY_INCOMPLETE = NonrequestableReasonEnum.QUALIFY_INCOMPLETE,
  NO_MENTOR = NonrequestableReasonEnum.NO_MENTOR,
  ONLY_MENTOR = NonrequestableReasonEnum.ONLY_MENTOR,
  INVALID_SERVICE_AREA = NonrequestableReasonEnum.INVALID_SERVICE_AREA,
  UNCERTIFIED_ORG_USER = NonrequestableReasonEnum.UNCERTIFIED_ORG_USER,
  REQUEST_IN_PROGRESS = NonrequestableReasonEnum.REQUEST_IN_PROGRESS,
}

export enum SoloNonrequestableReasonEnum {
  QUALIFY_INCOMPLETE = NonrequestableReasonEnum.QUALIFY_INCOMPLETE,
  ALREADY_REQUESTED = NonrequestableReasonEnum.ALREADY_REQUESTED,
  NO_MENTOR = NonrequestableReasonEnum.NO_MENTOR,
  ONLY_MENTOR = NonrequestableReasonEnum.ONLY_MENTOR,
  INVALID_SERVICE_AREA = NonrequestableReasonEnum.INVALID_SERVICE_AREA,
  UNCERTIFIED_ORG_USER = NonrequestableReasonEnum.UNCERTIFIED_ORG_USER,
  REQUEST_IN_PROGRESS = NonrequestableReasonEnum.REQUEST_IN_PROGRESS,
  OUTSIDE_SERVICE_REGIONS = NonrequestableReasonEnum.OUTSIDE_SOLO_REGIONS,
  LIGHTREACH_ALREADY_REQUESTED = NonrequestableReasonEnum.LIGHTREACH_ALREADY_REQUESTED,
}

export enum LightreachNonrequestableReasonEnum {
  QUALIFY_INCOMPLETE = NonrequestableReasonEnum.QUALIFY_INCOMPLETE,
  NO_MENTOR = NonrequestableReasonEnum.NO_MENTOR,
  ONLY_MENTOR = NonrequestableReasonEnum.ONLY_MENTOR,
  INVALID_SERVICE_AREA = NonrequestableReasonEnum.INVALID_SERVICE_AREA,
  UNCERTIFIED_ORG_USER = NonrequestableReasonEnum.UNCERTIFIED_ORG_USER,
  REQUEST_IN_PROGRESS = NonrequestableReasonEnum.REQUEST_IN_PROGRESS,
  OUTSIDE_SERVICE_REGIONS = NonrequestableReasonEnum.OUTSIDE_LIGHTREACH_REGIONS,
}

export enum PaymentPaidToEnum {
  OWNER = "owner",
  SPONSOR = "sponsor",
  UPLINE = "upline",
  INFINITY = "infinity",
  MENTOR = "mentor",
  CONSULTANT = "consultant",
  MENTOR_UPLINE = "mentor_upline",
  SELLER = "seller",
  ORG = "enterprise",
  LEAD_GEN = "lead_generator",
  CLOSER = "closer",
  AMBASSADOR = "ambassador",
  LEAD_OWNER_UPLINE = "lead_owner_upline",
  LEAD_OFFERER = "lead_offerer",
  LEAD_OWNER = "lead_owner",
  MANAGER = "manager",
  SUPPORT = "support",
  SETTER = "setter",
}

export enum ProposalKindEnum {
  SOLO = "solo",
  LIGHTREACH = "lightreach",
  VISION = "vision",
  VISION_LITE = "vision_lite",
  FUNDING = "funding",
}
